<template>
    <div>
        <headerNav title="详情" />
        <div class="fbg" v-if="item">
            <div class="fheader" v-if="item.img">
                <div class="fimg">
                    <img :src="$baseurl+item.img" />
                </div>
            </div>
            <div class="fmain">
                <div class="ftit">
                    {{item.subTitle}}
                </div>
                <div class="fcontent">
                    <div class="fcontent-tit">
                        孕期能吃吗？
                    </div>
                    <div class="fcontent-stit">
                        <van-icon  color="#04e60f"  v-if="item.eatYunQi==0" name="checked" class="iconset" size="14"/>
                        <van-icon  :color="$abctheme.basecolor"  v-if="item.eatYunQi==1||item.eatYunQi==2" name="warning" class="iconset" size="14"/>
                        <van-icon  color="red"  v-if="item.eatYunQi==3" name="clear" class="iconset" size="14"/>
                        <span class="stit">{{item.eatYunQiName}}</span>
                    </div>
                    <div class="fcontent-content" v-if="item.eatYunQiReply">
                        {{item.eatYunQiReply}}
                    </div>
                </div>
                <div class="fcontent">
                    <div class="fcontent-tit">
                        坐月子能吃吗？
                    </div>
                    <div class="fcontent-stit">
                        <van-icon  color="#04e60f"  v-if="item.eatYueZi==0" name="checked" class="iconset" size="14"/>
                        <van-icon  :color="$abctheme.basecolor"  v-if="item.eatYueZi==1||item.eatYueZi==2" name="warning" class="iconset" size="14"/>
                        <van-icon  color="red"  v-if="item.eatYueZi==3" name="clear" class="iconset" size="14"/>
                        <span class="stit">{{item.eatYueZiName}}</span>
                    </div>
                    <div class="fcontent-content" v-if="item.eatYueZiReply">
                        {{item.eatYueZiReply}}
                    </div>
                </div>
                <div class="fcontent">
                    <div class="fcontent-tit">
                        哺乳期能吃吗？
                    </div>
                    <div class="fcontent-stit">
                        <van-icon  color="#04e60f"   v-if="item.eatBuRuQi==0" name="checked" class="iconset" size="14"/>
                        <van-icon  :color="$abctheme.basecolor"  v-if="item.eatBuRuQi==1||item.eatBuRuQi==2" name="warning" class="iconset" size="14"/>
                        <van-icon   color="red"  v-if="item.eatBuRuQi==3" name="clear" class="iconset" size="14"/>
                        <span class="stit">{{item.eatBuRuQiName}}</span>
                    </div>
                    <div class="fcontent-content" v-if="item.eatBuRuQiReply">
                        {{item.eatBuRuQiReply}}
                    </div>
                </div>
                 <div class="fcontent">
                    <div class="fcontent-tit">
                        宝宝能吃吗？
                    </div>
                    <div class="fcontent-stit">
                        <van-icon  color="#04e60f"   v-if="item.eatBaoBaoStatus==0" name="checked" class="iconset-1" size="14"/>
                        <van-icon  :color="$abctheme.basecolor"   v-else-if="item.eatBaoBaoStatus==1" name="warning" class="iconset-1" size="14"/>
                        <van-icon  color="red"  v-else-if="item.eatBaoBaoStatus==2" name="clear" class="iconset-1" size="14"/>
                        <van-icon  color="#369fff"  v-else name="clock" class="iconset" size="14"/>
                        <span class="stit">{{item.eatBaoBao}}</span>
                    </div>
                    <div class="fcontent-content" v-if="item.eatBaoBaoReply">
                        {{item.eatBaoBaoReply}}
                    </div>
                </div>
                <div class="fcontent" v-if="item.content">
                    <div class="fcontent-tit">
                    小贴士
                    </div>
                    <div class="fcontent-content" v-html="item.content"></div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            myhtml:'',
            vid:undefined,
            item:undefined
        }
    },
    created()
    {
        var query=this.$route.query;
        
        if(query.id)
        {
            this.vid=query.id;
        }
        this.queryinfo();
    },
    methods:
    {
        queryinfo()
        {
            this.ajax.post('/api/services/app/PhoneEat/QueryEatProductModel?id='+this.vid).then(x=>
            {
                this.item=x.result;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.fbg{
    background-color: #fff;
    font-size: 13px;
    color:#686868;
}
.fheader .fimg img{
    width: 100%;
    height: auto;
}
.fmain{
    padding: 0px 10px 10px 10px;
}
.ftit{
    padding: 10px 0px;
    border-bottom: 1px solid #e6e6e6;
}
.fcontent{
    padding: 10px 0px;
    border-bottom: 1px solid #e6e6e6;
}
.fcontent:last-child{
    border-bottom:none;
}
.fcontent-tit{
    font-size: 15px;
    margin:5px 0px;
    color:black;
    font-weight: bold;
}

.fcontent-stit{
    margin:10px 0px;
}
.iconset{
    vertical-align: -1px; 
}
.iconset-1{
    vertical-align: -2px; 
}
.stit{
    font-size: 13px;
    padding-left:3px;
    color:black;
}
</style>